import { ImageList } from "@mui/material";
import React from "react";
import { IFilesApiColor, IFilesApiMaterial } from "../../@types/FilesAPIModels";
import useResponsiveSizes from "../../hooks/useResponsiveSizes";
import FilesAPIProductModel from "../../models/standard/FilesAPIProductModel";
import { PRODUCT_GALLERY_DEFAULT_COLS } from "../../utils/constants";
import { getImageListItemStyle } from "../../utils/imgUtils";

// Optional: reuse existing item components (or create minimal ones)
import ColorImageListItem from "./ColorImageListItem";
import MaterialImageListItem from "./MaterialImageListItem";
import ProductTextureImageList from "./ProductTextureImageList";

interface TextureGalleryProps {
  selectedTab: number; // 0 => Products, 1 => Materials, 2 => Colors
  products: FilesAPIProductModel[];
  materials: IFilesApiMaterial[];
  colors: IFilesApiColor[];
}

const TexturesGallery: React.FC<TextureGalleryProps> = ({
  selectedTab,
  products,
  materials,
  colors
}) => {
  const imgListStyles = getImageListItemStyle();
  const sizes = useResponsiveSizes();

  let itemsToDisplay: any[] = [];
  if (selectedTab === 0) {
    itemsToDisplay = products;
  } else if (selectedTab === 1) {
    itemsToDisplay = materials;
  } else {
    itemsToDisplay = colors;
  }

  return (
    <ImageList
    gap={PRODUCT_GALLERY_DEFAULT_COLS}
    cols={PRODUCT_GALLERY_DEFAULT_COLS}
    rowHeight={100}
    sx={{
      ...imgListStyles,
      height: `${sizes.innerWindowHeight - sizes.headerHeight * 2.9}px`,
      margin: '.5rem .25rem',
      backgroundColor: " white",
      display: 'grid !important', // Ensure it's grid-based
      gridTemplateRows: 'repeat(auto-fill, 100px) !important', // Prevent implicit row expansion
      gridAutoRows: '100px !important', // Enforce fixed row heights
      alignItems: 'start', // Align items to the top
      '& .MuiImageListItem-root': {
        height: '100px !important', // Force strict height for each item
      },
    }}
    variant="standard"
  >
      {itemsToDisplay.map((item, index) => {
        if (selectedTab === 0) {
          return (
            <ProductTextureImageList
              key={`product-${index}`}
              product={item}
              index={index}
            />
          );
        } else if (selectedTab === 1) {
          return (
            <MaterialImageListItem
              key={`material-${index}`}
              material={item}
              index={index}
            />
          );
        } 
          return (
            <ColorImageListItem
              key={`color-${index}`}
              color={item}
              index={index}
            />
          );
        
      })}
    </ImageList>
  );
};

export default TexturesGallery;
